import { resetState, setFieldState } from './main';

const actions = {
	setFieldState,
	resetState,
};

export default actions;
